import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './PayoutRecipientsListItem.scss';
import {
    payoutProviderMapper
} from '@nexio/emvio-util-app';

export default class PayoutRecipientsListItem extends Component {
    static propTypes = {
        item: PropTypes.any,
        onGoToItem: PropTypes.func.isRequired
    };

    renderRecipientRef(RecipientRef) {
        return RecipientRef ? RecipientRef : '';
    }

    renderProviderType(providerType) {
        return providerType ? payoutProviderMapper[providerType].toUpperCase() : '';
    }

    renderFirstLast(firstName, lastName) {
        return firstName || lastName ? `${firstName} ${lastName}` : '';
    }

    render() {
        const payoutRecipient = this.props.item;

        return (
            <div
                className="payout-recipients-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="payout-recipients-list-item-left">
                    <span className="payout-recipients-ref">
                        {this.renderRecipientRef(payoutRecipient.recipientRef)}
                    </span>
                    <span className="payout-recipients-name">
                        {this.renderFirstLast(payoutRecipient.firstName, payoutRecipient.lastName)}
                    </span>
                </div>
                <div className="payout-recipients-list-item-right">
                    <span className="payout-recipients-provider">
                        {this.renderProviderType(payoutRecipient.providerType)}
                    </span>
                </div>
            </div>
        );
    }
}
